<style>
    .ly-total-amount {
        border:1px solid #dfe6ec;
        border-top: 0;
        text-align: right;
        color: #48576a;
        font-size: 12px;
        padding: 8px 50px;
    }
</style>
<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新建银行交易</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- <el-card class="box-card mt15">
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请粘贴复制的数据在此处"
              v-model="submitForm.textarea">
            </el-input>
        </el-card> -->
        <!-- 银行流水导入表单 start -->
        <ly-bank-table class="mt15" ref="note"></ly-bank-table>
        <!-- 银行流水导入表单  end  -->
    </div>
</template>
<script>
    /**
     * 客户回款，银行登记单 新增
     * @time 2017-10-25
     * @author zjs
     */
    import AddFormConfig from './add-form'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyRouterButton from '@c/router-button'
    import LyBankTable from '@c/note'

    import {mapGetters} from 'vuex'
    export default {
        mixins: [
            AddFormConfig, 
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyRouterButton,
            LyBankTable
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ])
        },
        data () {
            return {
                num1: "",
                submitLoad: false, // 提交按钮的状态标识
                submitForm: {
                    tag_type: 'bank',
                    uuid: '',
                    textarea: '', // 原始文本
                    arrayarea: [] // 编辑过后的流水列表内容
                } // 提交的表单数据
            }
        },
        mounted () {
            // 设置UUID
            this.submitForm.uuid = this.$utils.createUUID()
            // 初始设置制作单人
            this.initData()
        },
        watch: {
            userInfo () {
                this.initData()
            },
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'CheckinAdd') {
                    this.$refs['searchForm'].resetForm()
                    this.$refs['productTable'].resetList()
                    // 初始化数据
                    this.initData()
                }
            }
        },
        methods: {
            /**
             * 初始化的数据设置
             */
            initData () {
                console.log('inint')
                // 初始设置制作单人、收胎人
                this.$refs['searchForm'].initBindFormData({
                    clerk: this.userInfo.name
                })
            },
            /**
             * 验证并获取银行流水的数据
             */
            veriBankData () {
                let data = this.$refs.note.getData()
                if (data.length > 0) {
                    if (typeof data === 'string') {
                        this.submitForm.textarea = data
                        this.submitForm.arrayarea = []
                    } else {
                        this.submitForm.textarea = ''
                        this.submitForm.arrayarea = data
                    }
                    return true
                } else {
                    this.$message({
                        message: '请填入银行流水数据',
                        type: 'warning'
                    })
                    return false
                }
            },
            submit () {
                // 验证并获取银行流水的数据
                if (!this.veriBankData()) return false
                if (this.$refs['searchForm'].validateForm()) {
                    this.submitLoad = true
                    // 获得得查询的字段
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                    // 提交数据
                    this.$api.create('api/fluent',this.submitForm).then((rs) => {
                            this.$alert(rs.msg || '数据提交成功', '提交成功', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.submitLoad = false
                                    // 跳转到详情页面
                                    this.$router.push('/bill/payconfirm/info/' + rs.id)
                                }
                            });
                            // 更新UUID
                            this.submitForm.uuid = this.$utils.createUUID()
                    }).catch((error) => {
                            this.submitLoad = false
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                    })
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>